import { render, staticRenderFns } from "./ViewImportAttach.vue?vue&type=template&id=dface56a&scoped=true&"
import script from "./ViewImportAttach.vue?vue&type=script&lang=js&"
export * from "./ViewImportAttach.vue?vue&type=script&lang=js&"
import style0 from "./ViewImportAttach.vue?vue&type=style&index=0&id=dface56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dface56a",
  null
  
)

export default component.exports